import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { t } from "../i18n/t";
import { routes } from "../lib/routes";
import { Loading } from "./ui";

/** Render children only for a signed-in user; otherwise go to login and come back afterwards. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status, error, refresh, loggedOut } = useAuth();
  const location = useLocation();
  if (status === "loading") {
    return (
      <main className="page-center">
        <Loading />
      </main>
    );
  }
  if (status === "error") {
    return (
      <main className="page-center">
        <div className="notice notice-error" role="alert">
          <p>{error?.userMessage ?? t("errors.meFailed")}</p>
          <button type="button" className="btn btn-secondary" onClick={() => void refresh()}>
            {t("common.retry")}
          </button>
        </div>
      </main>
    );
  }
  if (status === "anonymous") {
    // After an explicit logout the visitor lands on the public front page.
    if (loggedOut) return <Navigate to={routes.home()} replace />;
    const here = location.pathname + location.search;
    return <Navigate to={routes.login(here === "/" ? undefined : here)} replace />;
  }
  return <>{children}</>;
}
